<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>KPNG Second Edition - Motion: Pushes and Pulls - Downloads and Resources</h3>
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>
      <div class="presentations">
        <h4>Teacher Resources <span style="font-weight: 300;">(Teacher Presentations, How-to Videos, &amp; Curriculum Updates)</span></h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FKPNG-2E_Activities_1-6_08212024.zip?alt=media&token=18d0104a-8fe3-4ab3-9683-c251b39eeea4" target="_blank">Teacher Presentations: Activities 1 - 6</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/157GGB1d-gOpRe1kdHuotqe1HNeEP6ABpbYG7hwisZTw/copy" target="_blank">KPNG Second Edition - Motion: Pushes and Pulls Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/15O3aSMGJgvfuMIRJGcMlRHysF9nFy8Wa/view" target="_blank">KPNG Second Edition - Motion: Pushes and Pulls Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/1qYUQNaI_cY4HoDtbjYoccZ8m6xDGrnyje8DnQWWy2sM/copy" target="_blank">KPNG Second Edition - Motion: Pushes and Pulls Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FKPNG-2E_PostAssessment_01272022.pdf?alt=media&token=b0f8f262-ade8-47ea-8937-44231ba7c028" target="_blank">KPNG Second Edition Post Assessment - Updated 5/31/2022</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2FKPNG-2E_PostAssessment_Spanish_05312022.pdf?alt=media&token=b340091c-a9ca-4d5f-9427-5dabf6e4fffa" target="_blank">KPNG Second Edition Post Assessment (Spanish) - Updated 5/31/2022</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1LoF4vLOarWEd1l3g82XRi0g0gqzpJDgq4wBpg7o9C98/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/13tVFrMRUWmNBS9-hgMT9tYYHOLcpdMQGvyr4DluOmEo/copy" target="_blank">Get the Ball Moving</a></li>
          <li><a href="https://docs.google.com/presentation/d/1lbPSifNo0MSLQB19wCDL-mk4UQMwIYTQVxoOvXjYa_E/copy" target="_blank">Motion Symbols Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1neAcEC-w6xT1BCWxqgE_oN1m-AIPYi64i71OTBqShXw/copy" target="_blank">Classroom Data Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/13JXTKSLqkztxlZjwvZMDTUA_pMfCf0OPOJHxzaqryZQ/copy" target="_blank">Collision Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Xn54LO62XOld8EtWi3WOr-bxaiAQIUfuI_ViyIArrRI/copy" target="_blank">KPNG Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1-qsyv54WjR7hu3C8u44SbShprynw5CV5OVI5GdnjFM0/copy" target="_blank">Motion Word Sort Cards - Lesson 3B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Mx5Er0UBb_-1Lknf0fgdBgC3nxXO4H1FzWGQULG0iB0/copy" target="_blank">Word Sort Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Cho_7eAPKO9H0X_bLCZLC07yhoGk7fJkdTG3W0wNZE0/copy" target="_blank">Motion Station Observations Handout</a></li>
          <li><a href="https://docs.google.com/presentation/d/166bHp1dO7MBlziu9KOAV64ADQCV4lnBH4uQx-xSMpXI/copy" target="_blank">Animal Engineering Card Set</a></li>
          <li><a href="https://docs.google.com/presentation/d/1twsjTDkTw0mJqsPy1PTbz53GZHzBBYYYE0QlSiyxboA/copy" target="_blank">Rearranging the Pieces</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
        <h4 style="margin-left: 10px;">Demonstration Videos</h4>
        <ul>
          <li><a href="https://drive.google.com/file/d/1061v-nVz8wcItn0V3Tv3FoKaIfrAKnT7/view?usp=sharing" target="_blank">Ball Investigation: Weight</a></li>
          <li><a href="https://drive.google.com/file/d/1mP2CZdqo3pBAXvFvKn6MTrATcHv62adJ/view?usp=sharing" target="_blank">Ball Investigation: Height of Ramp</a></li>
          <li><a href="https://drive.google.com/file/d/1A5AtpgxahZJuLNw-Xt87kpHjU-4ZJgnl/view?usp=sharing" target="_blank">Ball Collisions: Barrier</a></li>
          <li><a href="https://drive.google.com/file/d/16_UrmARYPP_XBYVz21mlB8-UGvR1tdqL/view?usp=sharing" target="_blank">Ball Collisions: Moving/Moving</a></li>
          <li><a href="https://drive.google.com/file/d/12EaVHYwq6_9XfIYmYQVq5zTxBXWtkB42/view?usp=sharing" target="_blank">Ball Collisions: Moving/Stationary</a></li>
          <li><a href="https://drive.google.com/file/d/1qjJQ2b-LhuydJr9TxdlsyXfOMshZT_zJ/view?usp=sharing" target="_blank">Ball Collisions: Moving/Same Size</a></li>
          <li><a href="https://drive.google.com/file/d/1lXnxf51enKcti2iWTvw34JqoqLdWlW5Q/view?usp=sharing" target="_blank">Toy Bus Moving - Different Perspectives</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
